import styled from "@emotion/styled";
import { stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React, { SVGProps } from "react";

interface IconProps {
	iconSvg: React.FC<SVGProps<SVGElement>>;
}

const ICON_CONTAINER_WIDTH = 128 / Math.SQRT2;

export const BackgroundIcon: React.FC<IconProps> = ({ iconSvg: IconSvg }) => (
	<MainContainer>
		<IconContainer>
			<IconSvg width={64} height={64} />
		</IconContainer>
	</MainContainer>
);

const MainContainer = styled.div`
	width: ${ICON_CONTAINER_WIDTH}px;
	height: ${ICON_CONTAINER_WIDTH}px;
	background-color: ${colors.primary10};
	border-radius: 16px;
	transform: rotate(45deg);
	${stack(undefined, "center", "center")};
	margin: 8px 0;
`;

const IconContainer = styled.div`
	transform: rotate(-45deg);
`;
